import React from 'react';
import logo from "../../assets/logo/providus-logo.svg";
import "./Header.css"
import { Link } from "react-router-dom"

function Header() {
  return (
    <div className="header">
      <Link to  ="/">
            <img className='header_logo' src= {logo} alt="logo"/>
      </Link>
    </div>
  );
}

export default Header;
